import { useState, useEffect, createContext, useContext } from "react";
import {
  createUserWithEmailAndPassword,
  getAdditionalUserInfo,
  GoogleAuthProvider,
  onAuthStateChanged,
  sendPasswordResetEmail,
  signInWithEmailAndPassword,
  signInWithPopup,
  signOut,
} from "firebase/auth";
import { auth } from "../firebase.js";
import { useNavigate } from "react-router-dom";

export const authContext = createContext();
export const useAuth = () => {
  const context = useContext(authContext);
  if (!context) throw new Error("There is not auth provider");
  return context;
};

export function AuthProvider({ children }) {
  const [userFirebase, setUserFirebase] = useState(null);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();
  const signup = (email, password) => {
    return createUserWithEmailAndPassword(auth, email, password);
  };

  const logout = () => {
    signOut(auth);
    setTimeout(function () {
      navigate("/login");
    }, 1000);
  };

  const login = (email, password) => {
    return signInWithEmailAndPassword(auth, email, password);
  };

  const loginWithGoogle = () => {
    const googleProvider = new GoogleAuthProvider();
    return signInWithPopup(auth, googleProvider);
  };

  const resetPassword = async (email) => sendPasswordResetEmail(auth, email);

  useEffect(() => {
    const unsuscribe = onAuthStateChanged(auth, (currentUser) => {
      setUserFirebase(currentUser);
      setLoading(false);
    });
    return () => {
      unsuscribe();
    };
  }, []);
  return (
    <authContext.Provider
      value={{
        signup,
        login,
        logout,
        loginWithGoogle,
        resetPassword,
        getAdditionalUserInfo,
        userFirebase,
        loading,
      }}
    >
      {children}
    </authContext.Provider>
  );
}
